import { inject, Injectable, InjectionToken } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { StorageService } from '@core/services/storage.service';
import { IConfiguratorDraft } from '../models/configurator.model';

export const CONFIGURATOR_DRAFT_VERSION = 1;

/** Where drafts are kept. Swapped for an API adapter once the backend supports the configurator. */
export interface IConfiguratorPersistenceAdapter {
  load(contextKey: string): Observable<IConfiguratorDraft | null>;
  save(contextKey: string, draft: IConfiguratorDraft): Observable<void>;
}

export const CONFIGURATOR_PERSISTENCE_ADAPTER = new InjectionToken<IConfiguratorPersistenceAdapter>(
  'CONFIGURATOR_PERSISTENCE_ADAPTER'
);

@Injectable()
export class ConfiguratorLocalDraftAdapter implements IConfiguratorPersistenceAdapter {
  private readonly storage = inject(StorageService);

  load(contextKey: string): Observable<IConfiguratorDraft | null> {
    try {
      const raw = this.storage.get(this.getKey(contextKey));
      const draft: IConfiguratorDraft | null = raw ? JSON.parse(raw) : null;
      return of(draft?.version === CONFIGURATOR_DRAFT_VERSION ? draft : null);
    } catch {
      return of(null);
    }
  }

  save(contextKey: string, draft: IConfiguratorDraft): Observable<void> {
    try {
      this.storage.put(this.getKey(contextKey), JSON.stringify(draft));
      return of(undefined);
    } catch (error) {
      return throwError(() => error);
    }
  }

  private getKey(contextKey: string): string {
    return `configurator-v2-${contextKey}`;
  }
}
